import { userIdentifierOf, type PreferenceStorage } from './display/displayPreference';

export const DEBTS_NAV_BETAS = ['tempo', 'pergunta'] as const;

export type DebtsNavBeta = typeof DEBTS_NAV_BETAS[number];

export const DEFAULT_DEBTS_NAV_BETA: DebtsNavBeta = 'tempo';

export const NAV_BETA_PARAM = 'menu';

const KEY_PREFIX = 'debtsNav.beta.';

const USER_KEY = 'user';

export const isDebtsNavBeta = (value: unknown): value is DebtsNavBeta =>
  typeof value === 'string' && (DEBTS_NAV_BETAS as readonly string[]).includes(value);

export const navBetaFromUrl = (params: URLSearchParams): DebtsNavBeta | null => {
  const value = params.get(NAV_BETA_PARAM);
  return isDebtsNavBeta(value) ? value : null;
};

export const writeNavBetaToUrl = (current: URLSearchParams, beta: DebtsNavBeta): URLSearchParams => {
  const params = new URLSearchParams(current);
  params.set(NAV_BETA_PARAM, beta);
  return params;
};

const storageKeyOf = (storage: PreferenceStorage): string | null => {
  try {
    const identifier = userIdentifierOf(storage.getItem(USER_KEY));
    return identifier ? `${KEY_PREFIX}${identifier}` : null;
  } catch {
    return null;
  }
};

export const readStoredNavBeta = (storage: PreferenceStorage | null): DebtsNavBeta | null => {
  if (!storage) return null;
  const key = storageKeyOf(storage);
  if (!key) return null;
  try {
    const value = storage.getItem(key);
    return isDebtsNavBeta(value) ? value : null;
  } catch {
    return null;
  }
};

export const writeStoredNavBeta = (storage: PreferenceStorage | null, beta: DebtsNavBeta): void => {
  if (!storage) return;
  const key = storageKeyOf(storage);
  if (!key) return;
  try {
    storage.setItem(key, beta);
  } catch {
    return;
  }
};

export const resolveNavBeta = (urlBeta: DebtsNavBeta | null, storedBeta: DebtsNavBeta | null): DebtsNavBeta =>
  urlBeta ?? storedBeta ?? DEFAULT_DEBTS_NAV_BETA;
